import { Injectable } from "@angular/core";
import { HandlerService } from "../comunicator-native/handler/handler";
import { ContaIonCaronteService } from "./domain-conta-ion-service";
import { DomainDataCaronteBrokerService } from "./domain-data-caronte-broker.service";
import { DomainDataMobileBrokerService } from "./domain-data-mobile-broker.service";
import { DomainDataMobileService } from "./domain-data-mobile.service";
import { DomainDataMockService } from "./domain-data-mock.service";
import { DomainDataService } from "./domain-data.service";
import { DomainOrigin } from "./model/domain-origin";
import { ContaIonService } from "./services/conta-ion.service";

@Injectable({
    providedIn: 'root'
})
export abstract class DomainFactoryService {

    private services = new Map<DomainOrigin, DomainDataService>();

    constructor(
        private handlerService: HandlerService,
        private service: ContaIonService) {
    }

    public getDomainService(origin: DomainOrigin) {
        if (this.services.has(origin)) {
            return this.services.get(origin);
        }
        else {
            return this.constructService(origin);
        }
    }

    private constructService(origin: DomainOrigin): DomainDataService {
        switch (origin) {
            case DomainOrigin.UserDomainMobile:
                const serviceUserMobile = new DomainDataMobileService(this.handlerService);
                this.services.set(origin, serviceUserMobile);
                return serviceUserMobile;
            case DomainOrigin.BrokerMobile:
                const serviceBrokerMobile = new DomainDataMobileBrokerService(this.handlerService);
                this.services.set(origin, serviceBrokerMobile);
                return serviceBrokerMobile;
            case DomainOrigin.BrokerCaronte:
                const serviceBrokerCaronte = new DomainDataCaronteBrokerService(this.handlerService);
                this.services.set(origin, serviceBrokerCaronte);
                return serviceBrokerCaronte;
            case DomainOrigin.CaronteContaIon:
                const serviceContaIon = new ContaIonCaronteService(this.service);
                this.services.set(origin, serviceContaIon);
                return serviceContaIon;
            case DomainOrigin.Mock:
                const serviceMock = new DomainDataMockService();
                this.services.set(origin, serviceMock);
                return serviceMock;
        }

    }

}

